import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { PrintButtonHeader } from '../2284Tab/2284Dialog/Pdf2284CommonUtils';
import {
  AdaGrid,
  CccmsRowGrid,
  HeaderSectionGrid,
  ProfB1NoteField,
  RenderCheckBoxSection,
  RenderFieldSectionData,
} from './ProfB1PdfFormCommonUtils';
import {
  getAdaFields,
  getCccmsData,
  getEnemiesCheckBox,
  getGangEnemyDisciplinData,
  getGangInfoCheckBox,
  getInstitutionalCheckBox,
  getNoContactRowData,
  getParoleViolationCheckBox,
  getParoleViolationData,
  getParticipantFields,
  getReadingLevelCheckBox,
  getRegistrationAndParoleFields,
  getReleaseAndControlingDate,
  getReleaseFields,
  getReleaseTypeData,
  getVeteranCheckBox,
  getWarrantRowData,
  historyOfConvictionslabel,
  rSuffixFields,
} from './ProfB1PdfFormConstants';

const ProfB1PdfForm = (props) => {
  const { open, setOpen } = props;
  const profB1Form = useSelector((state) => state?.profB1Form);
  const profB2Form = useSelector((state) => state?.profB2Form);

  const {
    episodeID = '',
    dateReceivedCDC = '',
    lengthOfTermInYrsAndMos = '',
    secondStrike = '',
    commitmentOffenses = '',
    comments = '',
    h11590NarcoticRegistration = '',
    participant: profB1Participant,
    pC296ViolentOrSeriousOffenderNotification = '',
    countyOfLastLegalResidence,
    city = '',
    paroleRegion = '',
    historyOfConvictions = '',
    rSuffixInCentralFile,
    rSuffixExplination = '',
    EPRD,
    RRD,
    PED,
    CDD,
    CDD_MAX,
    releaseDate,
    controllingDischargeDate,
    highControlSupervision,
  } = profB1Form || {};

  const { p290SexRegistration, p457_1ArsonRegistration } =
    profB1Participant || {};
  const { value: countyOfLastLegalResidenceValue } =
    countyOfLastLegalResidence || {};

  const { CDCNumber = '', participant, ADA, enemies } = profB2Form || {};
  const { participantName = '' } = participant || {};

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleClose = () => {
    setOpen(false);
  };

  const getParticipantFieldsData = getParticipantFields({
    CDCNumber,
    participantName,
    dateReceivedCDC,
    lengthOfTermInYrsAndMos,
    secondStrike,
  });
  const releaseAndControlingDate = getReleaseAndControlingDate({
    releaseDate,
    controllingDischargeDate,
    highControlSupervision,
  });
  const releaseTypeData = getReleaseFields({ EPRD, RRD, PED, CDD, CDD_MAX });
  const registrationData = getRegistrationAndParoleFields({
    h11590NarcoticRegistration,
    p290SexRegistration,
    p457_1ArsonRegistration,
    pC296ViolentOrSeriousOffenderNotification,
    countyOfLastLegalResidenceValue,
    city,
    paroleRegion,
  });
  const rSuffixData = rSuffixFields({
    rSuffixInCentralFile,
    rSuffixExplination,
  });
  const gangInfoData = getGangInfoCheckBox();
  const gangEnemiesData = getEnemiesCheckBox();
  const institutionalData = getInstitutionalCheckBox();
  const adaData = getAdaFields({ ADA });
  const veteranData = getVeteranCheckBox();
  const readingLevelData = getReadingLevelCheckBox();
  const cccmsData = getCccmsData();
  const paroleViolationCB = getParoleViolationCheckBox();
  const contactData = getNoContactRowData();
  const warrantData = getWarrantRowData();
  const releaseTypeCB = getReleaseTypeData({ releaseTypeData });
  const gangEnemyDisciplinCB = getGangEnemyDisciplinData({
    enemies,
    gangInfoData,
    gangEnemiesData,
    institutionalData,
  });
  const paroleViolation = getParoleViolationData({ paroleViolationCB });

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <PrintButtonHeader handlePrint={handlePrint} handleClose={handleClose} />
      <Grid container ref={componentRef}>
        <HeaderSectionGrid episodeID={episodeID} />
        <RenderFieldSectionData field={getParticipantFieldsData} />
        <ProfB1NoteField
          label="Commitment Offense(s)"
          value={commitmentOffenses}
          rows={2}
        />
        <ProfB1NoteField label="Comments" value={comments} rows={2} />
        <RenderFieldSectionData field={releaseAndControlingDate} />
        <RenderCheckBoxSection items={releaseTypeCB} />
        <RenderFieldSectionData field={registrationData} />
        <ProfB1NoteField
          label={historyOfConvictionslabel}
          value={historyOfConvictions}
        />
        <RenderFieldSectionData field={rSuffixData} />
        <RenderCheckBoxSection items={gangEnemyDisciplinCB} />
        <AdaGrid
          items={adaData}
          veteranCB={veteranData}
          readingLevelCB={readingLevelData}
        />
        <CccmsRowGrid items={cccmsData} />
        <RenderCheckBoxSection items={paroleViolation} />
        <CccmsRowGrid items={contactData} />
        <CccmsRowGrid items={warrantData} />
      </Grid>
    </Dialog>
  );
};

export default ProfB1PdfForm;

ProfB1PdfForm.defaultProps = {
  open: false,
  setOpen: () => {},
};

ProfB1PdfForm.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
